import { render } from "./ScaleChart.vue?vue&type=template&id=e01cf0fc&scoped=true"
import script from "./ScaleChart.vue?vue&type=script&lang=js"
export * from "./ScaleChart.vue?vue&type=script&lang=js"

import "./ScaleChart.vue?vue&type=style&index=0&id=e01cf0fc&scoped=true&lang=css"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e01cf0fc"]])

export default __exports__